import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from '../others/SpinnerBlock';
import TableHeadTdOrder from '../others/TableHeadTdOrder';
import { useClients } from './context/ClientsProvider';
import ClientsTableBody from './ClientsTableBody';

interface ClientsTableProps {
    clientsList: any[];
    fetchClients: (force?: boolean) => Promise<void>;
    setEditClientId: (clientId: number) => void;
    setInfoClientId: (clientId: number) => void;
}

const ClientsTable = ({ clientsList, fetchClients, setEditClientId, setInfoClientId }: ClientsTableProps) => {
    const { t } = useTranslation(['Clients']);
    const { showSpinner, clientsOrder, setClientsOrder, clientsDesc, setClientsDesc } = useClients();

    const handleOrderClick = (value: string, desc: boolean) => {
        setClientsOrder(value);
        setClientsDesc(desc);
    };

    return (
        <>
            <SpinnerBlock onlyBlur={true} show={showSpinner} />

            <div className="crm-table-wrap">
                <Table className="ClientsTable table-hover">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">
                                <TableHeadTdOrder
                                    title={t('fields.name')}
                                    onClick={handleOrderClick}
                                    value={clientsOrder}
                                    desc={clientsDesc}
                                    fieldName="v_clients.client_name"
                                />
                            </td>
                            <td className="head-email">
                                <TableHeadTdOrder
                                    title={t('fields.email')}
                                    onClick={handleOrderClick}
                                    value={clientsOrder}
                                    desc={clientsDesc}
                                    fieldName="v_clients.client_email"
                                />
                            </td>
                            <td className="head-status">
                                <TableHeadTdOrder
                                    title={t('fields.status')}
                                    onClick={handleOrderClick}
                                    value={clientsOrder}
                                    desc={clientsDesc}
                                    fieldName="v_clients.client_status"
                                />
                            </td>
                            <td className="head-leads">{t('fields.leads')}</td>
                            <td className="head-updated">
                                <TableHeadTdOrder
                                    title={t('fields.created')}
                                    onClick={handleOrderClick}
                                    value={clientsOrder}
                                    desc={clientsDesc}
                                    fieldName="v_clients.client_created"
                                />
                            </td>
                            <td className="head-action">{t('fields.action')}</td>
                        </tr>
                    </thead>

                    <ClientsTableBody
                        clientsList={clientsList}
                        fetchClients={fetchClients}
                        setEditClientId={setEditClientId}
                        setInfoClientId={setInfoClientId}
                    />
                </Table>
            </div>
        </>
    );
};

export default ClientsTable;
